module.exports = __webpack_public_path__ + "media/images/ow-bonus-kv@2x-311acdb69259c84d28905a7f6eb3132f.png";